/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { propertyHeatingTypeCodeSchema } from "./propertyHeatingTypeCodeSchema.ts";
import { z } from "zod";

export const propertyHeatingSchema = z.object({
      "heatings": z.array(z.lazy(() => propertyHeatingTypeCodeSchema).describe("Type de chauffage du bien — libellés, sous-catégories et compatibilité avec la nature dans form-rules/property-form.json (champ heatings)")).optional(),
  "heatingAge": z.number().describe("Année d'installation du chauffage").optional(),
  "collective": z.boolean().describe("Indique si le chauffage est collectif").optional(),
  "individual": z.boolean().describe("Indique si le chauffage est individuel").optional()
      })